import React from "react";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_ContentBox } from "@danishagro/shared/src/components/atoms/ContentBox/ContentBox.component";
import { SSH_ListOfEmployees } from "@danishagro/sharedShop/src/components/organisms/ListOfEmployees";

interface V1Props {
    parentVersion?: string;
}

const V1 = (_props: V1Props) => {
    return (
        <DA_Container>
            <DA_ContentBox>
                <SSH_ListOfEmployees />
            </DA_ContentBox>
        </DA_Container>
    );
};

export default V1;
